/** ========================================================================= *\
 * @prefab Background
 * ========================================================================== */
import * as CONST from 'config';

class Background extends Phaser.Group {

  /** Entity List ----------------------------------------------------------- */
  static Entities = [
    {
      from: 0,
      to: 0.5,
      entities: [
        { key: "city1", weight: 0.3, },
        { key: "city2", weight: 0.3, },
        // { key: "city3", weight: 0.3, },
        // { key: "city4", weight: 0.4, }
      ]
    },
    {
      from: 0.5,
      to: 1,
      entities: [
        // { key: "city1", weight: 0.3, },
        // { key: "city2", weight: 0.3, },
        { key: "city3", weight: 0.3, },
        { key: "city4", weight: 0.4, }
      ]
    },
  ]

  /** Class Properties ------------------------------------------------------ */
  game = undefined;

  /** @constructor ---------------------------------------------------------- */
  constructor(game) {
    super(game);
    this.game = game;
    this._generateEntities();
  }

  _generateEntities() {
    let x = 0;
    const density = CONST.BACKGROUND_DENSITY;
    while (x < this.game.world.width) {
      const progress = x / this.game.world.width;
      const entity = this._getRandomEntity(progress);

      // Draw entity
      const scaleFactor = (getRandomInt(0, 20) - 10) / 100;
      const sprite = new Phaser.Sprite(this.game, x, this.game.world.height - CONST.FLOOR_HEIGHT, entity.key);
      sprite.anchor.set(0.5, 1);
      sprite.scale = new Phaser.Point(0.4 + scaleFactor, 0.4 + scaleFactor);
      this.add(sprite);

      // Increase counter
      x += density + getRandomInt(-0.2 * density, 0.2 * density);
    }
  }

  _getRandomEntity(progress) {
    const entities = Background.Entities.find((set) => {
      return progress >= set.from && progress <= set.to;
    }).entities;

    return entities[Math.floor(Math.random() * entities.length)];
  }

}

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export default Background;



// WEBPACK FOOTER //
// ./js/prefabs/background.js